import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserContext } from '@blocs.auth';
import { gqlSystemRoleCode as SYSTEM_ROLE } from '@minecraft.graphql-types';
import { AppcuesContext } from './AppcuesContext';
import checkSetup from './utils/checkSetup';

export const AppcuesProvider: FC = ({ children }) => {
  const [isSetup, setIsSetup] = useState<boolean>(false);
  const location = useLocation();
  const { myAccount, tokens } = useUserContext();
  const tokenInfo = tokens?.accessParsed;
  const appcues = window['Appcues'];

  useEffect(() => {
    if (!isSetup) return;

    appcues.page();
  }, [location, isSetup, appcues]);

  useEffect(() => {
    if (!myAccount || !checkSetup() || isSetup) return;

    const roleCode = tokenInfo?.role?.code;
    const { email, firstName, lastName, id, country } = myAccount;

    appcues.identify(
      id, // unique, required
      {
        isPC: roleCode === SYSTEM_ROLE.PROJECT_CREATOR,
        isCD: roleCode === SYSTEM_ROLE.CASTING_DIRECTOR,
        isRep: [SYSTEM_ROLE.AGENT, SYSTEM_ROLE.MANAGER].includes(roleCode),
        isStudio: roleCode === SYSTEM_ROLE.STUDIO,
        isCollaborator: roleCode === SYSTEM_ROLE.SHARED_PROJECT_USER,
        role: roleCode,
        countryCode: country?.code,
        email,
        firstName,
        lastName,
      }
    );
    setIsSetup(true);
  }, [myAccount, tokenInfo, appcues, isSetup]);

  // using context to possibly add tracking functionality later
  return (
    <>
      <AppcuesContext.Provider value={{}}>{children}</AppcuesContext.Provider>
    </>
  );
};
